import { useAuth } from "../../context/AuthContext";

function Topbar({ onMenuClick }) {
  const { admin, logout } = useAuth();

  return (
    <header className="bg-white border-bottom sticky-top d-flex align-items-center justify-content-between px-3 py-2">
      <button
        className="btn btn-light d-lg-none"
        onClick={onMenuClick}
        aria-label="Toggle menu"
      >
        <i className="bi bi-list fs-4"></i>
      </button>

      <div className="d-none d-lg-block"></div>

      <div className="d-flex align-items-center gap-3">
        <div className="text-end d-none d-sm-block">
          <div className="small fw-semibold">{admin?.full_name}</div>
          <div className="text-muted" style={{ fontSize: "0.75rem" }}>
            {admin?.role?.replace("_", " ")}
          </div>
        </div>
        <div
          className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
          style={{ width: "38px", height: "38px" }}
        >
          {admin?.full_name?.charAt(0).toUpperCase()}
        </div>
        <button className="btn btn-sm btn-outline-danger" onClick={logout}>
          <i className="bi bi-box-arrow-right"></i>
        </button>
      </div>
    </header>
  );
}

export default Topbar;
